import { FC, MouseEvent } from 'react';
import { CircularProgress } from '@mui/material';
import { AddVoucherPaymentDialogProps } from '../../../models/VoucherPayment.interface';
import {
  VoucherPaymentStyledDialog,
  VoucherPaymentRelativePositionBox,
  VoucherPaymentCloseIcon,
  VoucherPaymentFormContentBox,
  VoucherPaymentScrollableFormContent,
  VoucherPaymentButtonContainer,
  VoucherPaymentCancelButton,
  VoucherPaymentBorderedSectionBox,
  VoucherPaymentSectionTitleTypography,
  VoucherPaymentHeaderBoxSimple,
  VoucherPaymentTitleTypographyLarge,
  VoucherPaymentSubtitleTypographySimple,
  VoucherPaymentSubmitButton,
  VoucherPaymentFormContainer,
  VoucherPaymentStyledCircularProgress,
} from './VoucherPaymentDialog.styles';

const AddVoucherPaymentDialog: FC<AddVoucherPaymentDialogProps> = ({
  open,
  handleClose,
  title,
  subtitle,
  children,
  onSubmit,
  buttonLabel = 'Save',
  buttonDisabled,
  onSaveClick,
  paymentModeSection,
}) => {
  const handleSave = (e: MouseEvent) => {
    e.preventDefault();
    onSaveClick?.();
  };

  return (
    <VoucherPaymentStyledDialog open={open} onClose={handleClose}>
      <VoucherPaymentRelativePositionBox>
        <VoucherPaymentCloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </VoucherPaymentRelativePositionBox>
      <VoucherPaymentHeaderBoxSimple>
        <VoucherPaymentTitleTypographyLarge>
          {title}
        </VoucherPaymentTitleTypographyLarge>
        <VoucherPaymentSubtitleTypographySimple>
          {subtitle}
        </VoucherPaymentSubtitleTypographySimple>
      </VoucherPaymentHeaderBoxSimple>
      <VoucherPaymentFormContainer onSubmit={onSubmit}>
        <VoucherPaymentScrollableFormContent>
          <VoucherPaymentFormContentBox>
            {children}
          </VoucherPaymentFormContentBox>
          {paymentModeSection && (
            <VoucherPaymentBorderedSectionBox>
              <VoucherPaymentSectionTitleTypography>
                Payment Method
              </VoucherPaymentSectionTitleTypography>
              {paymentModeSection}
            </VoucherPaymentBorderedSectionBox>
          )}
          <VoucherPaymentButtonContainer>
            <VoucherPaymentSubmitButton
              type="button"
              disabled={buttonDisabled}
              onClick={handleSave}
            >
              {buttonDisabled ? (
                <VoucherPaymentStyledCircularProgress>
                  <CircularProgress size={20} />
                </VoucherPaymentStyledCircularProgress>
              ) : (
                buttonLabel
              )}
            </VoucherPaymentSubmitButton>
            <VoucherPaymentCancelButton type="button" onClick={handleClose}>
              Cancel
            </VoucherPaymentCancelButton>
          </VoucherPaymentButtonContainer>
        </VoucherPaymentScrollableFormContent>
      </VoucherPaymentFormContainer>
    </VoucherPaymentStyledDialog>
  );
};

export default AddVoucherPaymentDialog;
